import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SmoothCollapse from "react-smooth-collapse";

import { TextLink } from "../TextLink";

import styles from "./CookieConsent.scss";

function CookieAdditionalInfo({
  children,
  collapsed: collapsedProp,
  collapseCaption,
  expandCaption,
  ...otherProps
}) {
  const [collapsed, setCollapsed] = useState(collapsedProp);

  useEffect(() => {
    setCollapsed(collapsedProp);
  }, [collapsedProp]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleClick = (event) => {
    event.preventDefault();
    toggleCollapsed();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      // handle only enter and space
      event.preventDefault();
      toggleCollapsed();
    }
  };

  return (
    <div className={styles.info} {...otherProps}>
      <SmoothCollapse
        expanded={!collapsed}
        heightTransition="0.4s ease"
        aria-hidden={collapsed}
      >
        {children}
      </SmoothCollapse>

      <TextLink
        className={styles["collapse-toggle"]}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        href="#"
        tabIndex={0}
      >
        {collapsed ? expandCaption : collapseCaption}
      </TextLink>
    </div>
  );
}

CookieAdditionalInfo.defaultProps = {
  collapsed: true,
  collapseCaption: "Weniger erfahren",
  expandCaption: "Mehr erfahren",
};

CookieAdditionalInfo.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  collapsed: PropTypes.bool,
  collapseCaption: PropTypes.string,
  expandCaption: PropTypes.string,
};

CookieAdditionalInfo.displayName = "CookieConsent.Option.AdditionalInfo";

export default CookieAdditionalInfo;
